import { Descriptions } from "@/components/v2";
import { type DescriptionsProps } from "antd";
import { Company } from "@rumble-it/common-lib/types/models/Company.interface";
import { getMapsLink } from "@/lib/helpers/links";
import { Card } from "@rumbledirect/ui";

interface DealershipCompanyCardProps {
  dealershipCompany: Company | undefined;
  isLoading?: boolean;
}

export const DealershipCompanyCard = ({
  dealershipCompany,
  isLoading,
}: DealershipCompanyCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Bedrijfsnaam",
      children: dealershipCompany?.fullName,
    },
    {
      label: "Type",
      children: dealershipCompany?.type,
    },
    {
      label: "E-mail",
      children: dealershipCompany?.email,
    },
    {
      label: "Telefoon",
      children: dealershipCompany?.telephone,
    },
    {
      label: "Adres",
      children: dealershipCompany?.address ? (
        <>
          <a
            href={getMapsLink({ address: dealershipCompany.address })}
            target="_blank"
            rel="noopener noreferrer"
          >
            {`${dealershipCompany.address.street} ${dealershipCompany.address.streetNumber}${dealershipCompany.address.streetNumberAddition || ""}`}{" "}
            <br />
            {dealershipCompany.address.postalCode}{" "}
            {dealershipCompany.address.city}{" "}
            {dealershipCompany.address.country ? (
              <>
                <br />
                {dealershipCompany.address.country}
              </>
            ) : null}
          </a>
        </>
      ) : null,
    },
  ];

  // Don't render the card if there's no dealership company data
  if (!dealershipCompany) {
    return null;
  }

  return (
    <Card loading={isLoading} className="w-full" title="Dealerbedrijf">
      <Descriptions items={items} />
    </Card>
  );
};
